module.exports = __webpack_public_path__ + "img/purpleTopBg.c19f9e2f.png";